/** Job titles for the Clinic Role dropdown - a NEW, separate vocabulary from ClinicUser's
 * role choices (dvm/owner/reporter/doctor/other, a relationship/permission list, not job
 * titles). Must stay in sync with CLINIC_CONTACT_ROLE_CHOICES in server/app/models.py. */
export const CLINIC_CONTACT_ROLE_OPTIONS = [
    { value: 'receptionist', label: 'Receptionist' },
    { value: 'owner', label: 'Owner' },
    { value: 'veterinarian', label: 'Veterinarian' },
    { value: 'technician', label: 'Technician' },
    { value: 'office_manager', label: 'Office Manager' },
    { value: 'inventory_manager', label: 'Inventory Manager' },
];
export const clinicContactRoleLabel = (value) => CLINIC_CONTACT_ROLE_OPTIONS.find((option) => option.value === value)?.label || value;
export const normalizeClinicContact = (item) => ({
    id: item.id,
    clinic: item.clinic,
    first_name: item.firstName ?? item.first_name ?? '',
    last_name: item.lastName ?? item.last_name ?? '',
    email: item.email ?? null,
    phone: item.phone ? { number: item.phone.number } : null,
    role: item.role ?? '',
    is_primary: item.isPrimary ?? item.is_primary ?? false,
    created_at: item.createdAt ?? item.created_at ?? '',
});
